'use strict';
/**
 * @author Maxim Seredkin
 */
export default ['$scope', 'LandCategoryService',
    function ($scope, LandCategoryService) {
        $scope.orgs = [];

        LandCategoryService.api.get(null, (data) => $scope.categories = [{
            id: null,
            name: "<Все>"
        }].concat(data._embedded));
    }];
